import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { UndoRequestResponse } from '../types/Dimension'
import { useUndoOptions } from './useUndoOptions'

export const useUndo = <Entity, TData = UndoRequestResponse<Entity>[]>(
  select?: (data: UndoRequestResponse<Entity>[]) => TData
) => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const options = useUndoOptions({ companyId, select })
  return useQuery(options)
}
